import React from "react";
import { Container, Grid } from '@material-ui/core'
import { HeaderHLPure, PromotionalFooterPure, InputHLPure, ButtonHLPure, DialogSystemGLPure, SimpleLoading } from "../../pures";
import { useTranslation } from "react-i18next";
import './validation-signature-base.css';

const ValidationSignatureBaseView = (props) => {
    let {
        headerTitle,
        isLoadingView,
        showLoadingRequesting,
        toggleLoadingRequesting,
        showCompletedRequesting,
        toggleCompletedRequesting,
        showErrorRequesting,
        toggleErrorRequesting,
        messageError,
        firstName,
        firstLastName,
        secondLastName,
        ineFrontImg,
        ineBackImg,
        backBtn,
        rejectBtn,
        cancelBtn,
        validateBtn,
        showBackBtn,
        showRejectBtn,
        showCancelBtn,
        showNextBtn,
        handleBack,
        handleReject,
        handleCancel,
        handleValidate,
        statusCancel
    } = props

    const { t } = useTranslation();

    if(isLoadingView) return <SimpleLoading />

    return(
        <div className="validationSignatureBaseView-wrapper">
            <Container>
                <Grid container spacing={2}>
                    <div className="validationSignatureBaseView-header">
                        <HeaderHLPure title={headerTitle} />
                    </div>
                    <div className="validationSignatureBaseView-body">
                        <div className="validationSignatureBaseView-container-items">
                            <div className="validationSignatureBaseView-items">
                                <div className="validationSignatureBaseView-container-inputs">
                                    <InputHLPure
                                        labelInput={t("profileAdministrationPrincipalView.name")}
                                        valueInput={firstName}
                                        typeInput={"text"}
                                        inputActive={true}
                                        disabled
                                    />
                                    <InputHLPure
                                        labelInput={t("profileAdministrationPrincipalView.firstLastName")}
                                        valueInput={firstLastName}
                                        typeInput={"text"}
                                        inputActive={true}
                                        disabled
                                    />
                                    <InputHLPure
                                        labelInput={t("profileAdministrationPrincipalView.secondLastName")}
                                        valueInput={secondLastName}
                                        typeInput={"text"}
                                        inputActive={true}
                                        disabled
                                    />
                                </div>
                                <div className="validationSignatureBaseView-container-images">
                                    <div className="validationSignatureBaseView-ine-front">
                                        <div className={"rec-signature-base"}>
                                            <img className={"signatureBaseUploadINE-image-ine "} src={ineFrontImg} />
                                        </div>
                                    </div>
                                    <div className="validationSignatureBaseView-ine-back">
                                        <div className={"rec-signature-base "} >
                                            <img className={"signatureBaseUploadINE-image-ine"} src={ineBackImg} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="validationSignatureBaseView-container-btns">
                        {
                            showBackBtn && (
                                <div className="validationSignatureBaseView-btn-secundary">
                                    <ButtonHLPure
                                        nameBtn={backBtn}
                                        primary={false}
                                        onClickBtn={() => handleBack()}
                                    />
                                </div>
                            )
                        }
                        {
                            showRejectBtn && (
                                <div className="validationSignatureBaseView-btn-secundary">
                                    <ButtonHLPure
                                        nameBtn={rejectBtn}
                                        primary={false}
                                        onClickBtn={() => handleReject()}
                                    />
                                </div>
                            )
                        }
                        {
                            showCancelBtn && (
                                <div className="validationSignatureBaseView-btn-secundary">
                                    <ButtonHLPure
                                        nameBtn={cancelBtn}
                                        primary={false}
                                        onClickBtn={() => handleCancel(statusCancel)}
                                    />
                                </div>
                            )
                        }
                        {
                            showNextBtn && (
                                <ButtonHLPure
                                    nameBtn={validateBtn}
                                    primary={true}
                                    onClickBtn={() => handleValidate()}
                                />
                            )
                        }
                    </div>
                    <Grid item xs={12} lg={12} md={12} sm={12}>
                        <PromotionalFooterPure />
                    </Grid>
                    <DialogSystemGLPure
                        showLoadingRequesting={showLoadingRequesting}
                        toggleLoadingRequesting={toggleLoadingRequesting}

                        showCompletedRequesting={showCompletedRequesting}
                        toggleCompletedRequesting={toggleCompletedRequesting}

                        showErrorRequesting={showErrorRequesting}
                        toggleErrorRequesting={toggleErrorRequesting}
                        messageError={messageError} 
                    />
                </Grid>
            </Container>
        </div>
    )
}

export { ValidationSignatureBaseView as default }